module.exports = __webpack_public_path__ + "img/livro.d5c9667b.png";